import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { NbDialogService } from '@nebular/theme';
import { BuildingEditModalComponent } from './edit/building-edit-modal.component';
import { ConfirmModalComponent } from '../modals/confirm-modal.component';

import { MissionService, GameService, TemplateService, BuildingService, LanguageService, ResourceService } from '../../_services/index';
import { Building } from '../../classes';

@Component({
    selector: 'app-edit-buildings',
    templateUrl: './edit-buildings.component.html',
    styleUrls: ['./edit-buildings.component.scss'],
    standalone: false
})

export class EditBuildingsComponent {

  buildings = [];
  buildingsSubscriber;
  resources = [];
  resourcesSubscriber;

  gameId;
  game;
  templateId;
  template;

  url;

  constructor(private route: ActivatedRoute,
    public buildingService: BuildingService,
    public resourceService: ResourceService,
    public gameService: GameService,
    public missionService: MissionService,
    public templateService: TemplateService,
    private dialogService: NbDialogService,
    public languageService: LanguageService) {
      this.route
      .params
      .subscribe(params => {
        // Récupération des valeurs de l'URL
        console.log('params:'+JSON.stringify(params));
        this.gameId = params['id'];
        this.templateId = params['templateId'];
        console.log('Load data - gameId:'+this.gameId+', templateId:'+this.templateId);
        
        if(this.buildingsSubscriber){
          this.buildingsSubscriber.unsubscribe();
        }
        if(this.resourcesSubscriber){
          this.resourcesSubscriber.unsubscribe();
        }
        if(this.gameId){
          this.gameService.getGame(this.gameId)
          .subscribe(game => {
            if(game){
              this.game = game;
            }
          });
          this.buildingsSubscriber = this.buildingService.listBuildings(`games/${this.gameId}/buildings`)
          .subscribe(buildings => {;
            if(buildings){
              this.buildings = this.sort(buildings);
            }
          });
          this.resourcesSubscriber = this.resourceService.listResources(`games/${this.gameId}/resources`)
          .subscribe(resources => {
            if(resources){
              this.resources = resources;
            }
          });
        }
        else if(this.templateId){
          this.templateService.getTemplate(this.templateId)
          .subscribe(template => {
            if(template){
              this.template = template;
            }
          });
          this.buildingsSubscriber = this.buildingService.listBuildings(`game_templates/${this.templateId}/buildings`)
          .subscribe(buildings => {
            if(buildings){
              this.buildings = this.sort(buildings);
            }
          });
          this.resourcesSubscriber = this.resourceService.listResources(`game_templates/${this.templateId}/resources`)
          .subscribe(resources => {
            if(resources){
              this.resources = resources;
            }
          });
        }
      });
  }

  containsOrder(objects) {
    let exist = true
    for (let i = 0; i < objects.length; i++) {
      if (!objects[i]?.orderNum) {
        exist = false;
      }
    }
    return exist;
  }

  sort(objects){
    return objects.sort((x, y) => x.orderNum - y.orderNum);
  }

  changePosition(old_order, new_order, object){
    let old_index = this.buildings.findIndex(obj => obj.objectTypeId == object.objectTypeId && old_order == obj.orderNum);
    let new_index = this.buildings.findIndex(obj => obj.objectTypeId == object.objectTypeId && new_order == obj.orderNum);
    console.log('old_index:'+old_index);
    console.log('new_index:'+new_index);
    console.log('this.objects[new_index]:'+this.buildings[new_index]);
    if(this.buildings[new_index]){
      this.buildings[old_index].orderNum = new_order
      this.buildings[new_index].orderNum = old_order
      
      this.saveOrder(this.buildings[old_index])
      this.saveOrder(this.buildings[new_index])
      //this.objects = this.sort(this.objects)
    }
  }

  async saveOrder(resource){
    await this.buildingService.setBuilding(resource).then(value => {
    }, err => {
      console.log('err :', err)
    });
  }

  ngOnInit() {
  }

  editBuilding(building){
    if(this.gameId){
      if(!building){
        building = new Building(`games/${this.game.id}/buildings`);
        building.gameId = this.gameId;
        building.orderNum = this.buildings.length+1;
      }
      this.dialogService.open(BuildingEditModalComponent, { 
        context: {
          model: building,
          game: this.game,
          languages: this.game.workingLanguages,
          resources: this.resources
        }, closeOnBackdropClick: false
      })
      .onClose.subscribe(res => {
        console.log('Dialog returns:'+res);
      });
    } else {
      if(!building){
        building = new Building(`game_templates/${this.templateId}/buildings`);
        building.templateId = this.templateId;
      }
      this.dialogService.open(BuildingEditModalComponent, { 
        context: {
          model: building,
          game: this.game,
          languages: this.template.workingLanguages,
          resources: this.resources
        }, closeOnBackdropClick: false
      })
      .onClose.subscribe(res => {
        console.log('Dialog returns:'+res);
      });
    }
  }

  deleteBuilding(building){
    this.dialogService.open(ConfirmModalComponent, { 
      context: {
        title: 'Confirmation',
        message: `Do you want to delete building '`+building.labels[this.languageService.currentLang]+`'?`
      }, closeOnBackdropClick: false
    })
    .onClose.subscribe(async res => {
      console.log('Dialog returns:'+res);
      if(res){
        console.log('Delete building');
        await this.buildingService.deleteBuilding(building);
      }
    });
  }
}